module.exports = __webpack_public_path__ + "static/media/dual_loader.04f2e934.svg";